import React from 'react'
import { useSelector } from 'react-redux'
import assignmentSelectors from '../../../../../store/selectors/assignment.selectors'
import { isNewTextAssignment } from '../../../../../utils/assignment.helper'
import CsAnalyticsReportSection from './cs/CsAnalyticsReportSection'
import TextAnalyticsReportSection from './text/TextAnalyticsReportSection'
import { useDocumentTitle } from '../../../../../hooks/useDocumentTitle'

const AnalyticsReportSection = () => {
    const language = useSelector(assignmentSelectors.language)
    const assignmentName = useSelector(assignmentSelectors.name)

    useDocumentTitle(`${assignmentName || ''} Analytics`)

    if (!language) return null
    return isNewTextAssignment(language) ? <TextAnalyticsReportSection /> : <CsAnalyticsReportSection />
}

export default AnalyticsReportSection
